module.exports = __webpack_public_path__ + "static/media/h270_8.e8f452b2259b7e0aaf6fecd25cd1f5c1.png";